const reNonWhiteSpace = /\S/;
export const firstNonWhitespaceIndex = (text) => {
    return text.search(reNonWhiteSpace);
};
//# sourceMappingURL=utils.js.map